import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { LoadingComponent } from "@digi-america/shared";
import { UtcToLocalTimePipe } from '../../pipes/utc-to-local.pipe';
import { DealDeskService } from '../../services/deal-desk.service';
import { ResponseDealDesk } from '../../types/dai-server/deal-desk/deal-desk-responses';
import { DealDeskStatus, dealDeskStatusLabel, normalizeDealDeskStatus } from '../../types/dai-server/deal-desk/enums';

@Component({
  selector: 'app-deal-desk-view',
  imports: [CommonModule, RouterLink, LoadingComponent, UtcToLocalTimePipe],
  templateUrl: './deal-desk-view.component.html',
  styleUrl: './deal-desk-view.component.scss',
  standalone: true
})
export class DealDeskViewComponent implements OnInit {
  dealDeskId!: string;
  dealDesk?: ResponseDealDesk;
  loadFailed = false;

  constructor(private _dealDesks: DealDeskService, private _routes: ActivatedRoute) { }

  ngOnInit(): void {
    this._routes.params.subscribe({
      next: (values) => {
        this.dealDeskId = values['dealDeskId'];
        this.load();
      }
    });
  }

  async load() {
    this.dealDesk = undefined;
    this.loadFailed = false;
    try {
      this.dealDesk = await firstValueFrom(this._dealDesks.getDealDesk(this.dealDeskId));
    } catch {
      this.loadFailed = true;
    }
  }

  statusLabel(status: string | null): string {
    return dealDeskStatusLabel(status);
  }

  statusClass(status: string | null): string {
    switch (normalizeDealDeskStatus(status)) {
      case DealDeskStatus.approved:
        return "bg-success";
      case DealDeskStatus.approvedWithChanges:
        return "bg-info";
      case DealDeskStatus.rejected:
        return "bg-danger";
      case DealDeskStatus.moreInfoRequested:
        return "bg-warning text-dark";
      default:
        return "bg-secondary";
    }
  }
}
